/* src/app/components/analytics/case-analytics/items/skeleton-loaders/doughnut/doughnut-skeleton-loader.component.scss */
.pulse,
.skeleton,
.skeleton:before,
.fg-2,
.fg,
:host {
  animation: pulse var(--animation-duration, 0.7s) cubic-bezier(0.4, 0, 0.6, 1) infinite;
  animation-delay: var(--animation-delay, 0s);
}
@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: var(--pulse-opacity, 0.5);
  }
  100% {
    opacity: 1;
  }
}
.shimmer,
.skeleton,
.axes,
.legend,
:host {
  position: relative;
}
.shimmer:after,
.skeleton:after,
.axes:after,
.legend:after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: var(--shimmer-gradient, linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.02) 20%, rgba(255, 255, 255, 0.65) 60%, rgba(255, 255, 255, 0)));
  animation: shimmer 3.2s 1.6s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  50% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(100%);
  }
}
.skeleton,
:host {
  --background-color: rgb(239, 240, 242);
  --foreground-color-1: rgb(212, 214, 216);
  --foreground-color-2: rgb(196, 198, 200);
  --grid-line-color: rgb(194, 196, 198);
  --border-radius: 5px;
  --animation-duration: 0.7s;
  --animation-delay: 0s;
  --shimmer-gradient:
    linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0,
      rgba(255, 255, 255, 0.02) 20%,
      rgba(255, 255, 255, 0.65) 60%,
      rgba(255, 255, 255, 0));
}
:host-context(.dark-theme) .skeleton,
:host-context(.dark-theme) :host {
  --background-color: rgb(70 71 72);
  --foreground-color-1: rgb(90 91 92);
  --foreground-color-2: rgb(80, 81, 82);
  --foreground-color-3: rgb(78 82 82);
  --foreground-color-4: rgb(104 106 108);
  --foreground-color-5: rgb(120 122 124);
  --grid-line-color: rgb(90, 91, 92);
  --shimmer-gradient:
    linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0,
      rgba(255, 255, 255, 0.02) 20%,
      rgba(120, 121, 122, 0.9) 60%,
      rgba(255, 255, 255, 0));
}
.skeleton,
:host {
  background: var(--background-color);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
.skeleton:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--background-color);
  --pulse-opacity: 0.7;
  z-index: -1;
}
.bg {
  background: var(--background-color);
}
.fg-2 {
  border-radius: 2px;
  background: var(--foreground-color-2);
  --pulse-opacity: 0.7;
}
.fg {
  border-radius: 2px;
  background: var(--foreground-color-1);
  --pulse-opacity: 0.7;
}
:host {
  display: flex;
  flex-direction: row;
  height: inherit;
  width: 100%;
  gap: 5px;
  opacity: 1;
  background: transparent;
  --foreground-color-3: rgb(178, 180, 182);
  --foreground-color-4: rgb(159, 160, 162);
  --foreground-color-5: rgb(213, 216, 218);
}
.chart {
  height: 100%;
  width: 70%;
  background-color: var(--background-color, rgb(239, 240, 242));
}
.axes {
  height: 100%;
  width: 100%;
}
.y-axis,
.x-axis {
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.y-axis {
  position: relative;
  display: flex;
  align-items: center;
  width: fit-content;
  margin: 0 auto;
}
.x-axis {
  position: absolute;
  top: 0;
  left: 0;
}
.legend {
  width: 30%;
  height: 100%;
  overflow: hidden;
  background-color: var(--background-color, rgb(239, 240, 242));
}
.legend-wrapper {
  background-color: var(--background-color, rgb(239, 240, 242));
}
.outer-ring,
.doughnut,
.doughnut-box,
.legend {
  display: flex;
  align-items: center;
  justify-content: center;
}
.doughnut-box {
  height: 28vmin;
  width: 28vmin;
}
.doughnut {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.outer-ring {
  width: 100%;
  height: 100%;
  border-radius: 100%;
  background: var(--foreground-color-4);
  position: relative;
  overflow: hidden;
}
.inner-ring {
  width: 70%;
  height: 70%;
  border-radius: 100%;
  background: var(--foreground-color-3);
  position: relative;
  overflow: hidden;
}
.section {
  position: absolute;
  width: 0;
  height: 0;
  border-top: 20vmin solid transparent;
  border-bottom: 20vmin solid transparent;
  border-right: 20vmin solid transparent;
  border-left: 20vmin solid transparent;
}
.outer-ring .section:nth-child(1) {
  transform-origin: center;
  transform: rotateZ(30deg);
  border-left-color: var(--foreground-color-3);
}
.outer-ring .section:nth-child(2) {
  transform-origin: center;
  transform: rotateZ(120deg);
  border-left-color: var(--foreground-color-1);
}
.outer-ring .section:nth-child(3) {
  transform-origin: center;
  transform: rotateZ(180deg);
  border-left-color: var(--foreground-color-3);
}
.outer-ring .section:nth-child(4) {
  display: none;
}
.inner-ring .section {
  border-top: 12vmin solid transparent;
  border-bottom: 15vmin solid transparent;
  border-right: 10vmin solid transparent;
  border-left: 12vmin solid transparent;
}
.inner-ring .section:first-child {
  transform-origin: center;
  transform: rotateZ(300deg);
  border-left-color: var(--foreground-color-5);
}
.inner-ring .section:last-child {
  display: none;
}
.doughnut-hole {
  position: absolute;
  width: 35%;
  height: 35%;
  border-radius: 100%;
  background: var(--background-color);
}
.legend-wrapper {
  height: 65%;
  width: 80%;
  gap: 12px;
  border-radius: var(--border-radius);
  background: var(--foreground-color-1, rgb(212, 214, 216));
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.legend-item-wrapper {
  display: flex;
  align-items: center;
  justify-self: center;
  width: 100%;
  overflow: hidden;
}
.legend-item {
  height: 18px;
  width: 18px;
  border-radius: 100%;
  margin: 0 10px;
}
.legend-label {
  height: 20px;
  width: 70%;
  border-radius: var(--border-radius);
  margin: 0 0 0 10px;
}
.legend-item-wrapper:nth-of-type(2n+1) .legend-item,
.legend-item-wrapper:nth-of-type(2n+1) .legend-label {
  background-color: var(--foreground-color-4, rgb(159, 160, 162));
}
.legend-item-wrapper:nth-of-type(2n) .legend-item,
.legend-item-wrapper:nth-of-type(2n) .legend-label {
  background-color: var(--foreground-color-2, rgb(196, 198, 200));
}
/*# sourceMappingURL=doughnut-skeleton-loader.component.css.map */
